var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackMsg2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26043 4.0007C3.68683 3.98626 3.13011 4.19562 2.7082 4.58448C2.28628 4.97333 2.0323 5.51116 2 6.08403V17.0111C2 17.6741 2.26339 18.31 2.73223 18.7788C3.20107 19.2477 3.83695 19.5111 4.49999 19.5111H19.5C19.8286 19.5125 20.1544 19.4487 20.4583 19.3236C20.7622 19.1984 21.0384 19.0143 21.2708 18.7819C21.5032 18.5495 21.6873 18.2734 21.8125 17.9694C21.9376 17.6655 22.0014 17.3398 22 17.0111V6.09442C21.9703 5.52247 21.7185 4.98471 21.2983 4.5956C20.8781 4.20649 20.3225 3.99675 19.75 4.0111L4.26043 4.0007ZM6.4479 8.06319C6.17163 7.87947 5.83372 7.81302 5.50847 7.87846C5.18321 7.9439 4.89727 8.13587 4.71355 8.41214C4.52983 8.6884 4.46338 9.02634 4.52882 9.3516C4.59426 9.67686 4.78623 9.9628 5.0625 10.1465L11.3125 14.3132C11.5172 14.4511 11.7584 14.5248 12.0052 14.5248C12.252 14.5248 12.4932 14.4511 12.6979 14.3132L18.9479 10.1465C19.2241 9.9628 19.4161 9.67686 19.4816 9.3516C19.547 9.02634 19.4806 8.6884 19.2969 8.41214C19.1131 8.13587 18.8272 7.9439 18.5019 7.87846C18.1767 7.81302 17.8387 7.87947 17.5625 8.06319L12 11.7715L6.4479 8.06319Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackMsg2);
export default __webpack_public_path__ + "static/media/black-msg-2.98b89e36303d29bab48c03b729038afc.svg";
export { ForwardRef as ReactComponent };